module.exports = __webpack_public_path__ + "e2fe5e6b82bee327b8c9521ea24b8be3.MP3";